var _defs, _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2880 1440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M0,0 0.309017,0.951057 -0.5,0.363271H0.5L-0.309017,0.951057z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2880,
    height: 1440,
    fill: "#ce1126"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 720,
    fill: "#002b7f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(720,30) scale(160)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(500,210) scale(160)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(945,180) scale(150)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(830,364.894348) scale(100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(720,499.788697) scale(200)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWs);
export default __webpack_public_path__ + "static/media/ws.a5bc5f0894f19e3903ddbfb3c1748415.svg";
export { ForwardRef as ReactComponent };